import { jsx as e } from "react/jsx-runtime";

import { forwardRef as o } from "react";

import r from "../../hooks/useId/index.js";

import t from "../../hooks/useModalHandle/index.js";

import n from "../../utils/classNames/index.js";

import l from "./context/index.js";

import a from "./DrawerContent/index.js";

import i from "./DrawerFooter/index.js";

import s from "./DrawerHeader/index.js";

const m = Object.assign(o((({children: o, placement: a = "right", className: i, id: s, onCustomClose: m, opened: d, ...f}, c) => {
    const p = r(s), x = `${p}l`, {innerRef: u, close: h, softClose: C, onCancelFinal: j} = t({
        ref: c,
        onCustomClose: m,
        opened: d
    }), b = {
        close: h,
        softClose: C,
        labelId: x,
        idPrefix: `${p}c:`
    };
    return e(l.Provider, {
        value: b,
        children: e("dialog", {
            ...f,
            ref: u,
            "aria-labelledby": x,
            onCancel: j,
            className: n("z-[100] flex w-full max-w-[510px] flex-col border border-neutral-300 bg-white", i, "fixed top-0 m-0 min-h-screen opacity-0 transition-all duration-300 ease-linear open:flex open:translate-x-0 open:opacity-100", "right" === a ? "right-0 ml-auto translate-x-full" : "left-0 mr-auto -translate-x-full"),
            children: "function" == typeof o ? o(b) : o
        })
    });
})), {
    Header: s,
    Content: a,
    Footer: i,
    context: l
});

export { m as default };
//# sourceMappingURL=index.js.map
